import { forwardRef, useEffect, useRef, useState } from "react";
import { Autocomplete, AutocompleteOption, ListItemDecorator, createFilterOptions } from "@mui/joy";
import Add from "@mui/icons-material/Add";

const filter = createFilterOptions();

export default function TagSelect({
    options:defaultOptions = [],
    value = [],
    onChange,

    endpoint = '',
    include = '',

    ...restProps
}) {
    const [inputOptions, setInputOptions] = useState(defaultOptions);

    return (<>
        <Autocomplete
            value={value}
            onChange={(event, newValue, reason) => {
                let newVals = [];
                for(const newVal of newValue) {
                    // existing option
                    if(typeof newVal === 'string') {
                        newVals.push(newVal);
                    // new option
                    } else if(newVal && newVal.inputValue) {
                        setInputOptions([
                            ...inputOptions,
                            newVal.inputValue,
                        ]);
                        newVals.push(newVal.inputValue);
                    }
                }

                onChange(newVals, newVals);
            }}
            multiple
            selectOnFocus
            clearOnBlur
            handleHomeEndKeys
            freeSolo
            placeholder="Choose..."
            options={inputOptions}
            // getOptionLabel={(option) => option?.title ?? option}
            getOptionLabel={(option) => {
                // Value selected with enter, right from the input
                if (typeof option === 'string') {
                    return option;
                }

                // Add "xxx" option created dynamically
                if (option.inputValue) {
                    return option.inputValue;
                }

                // Regular option
                return option.title;
            }}
            renderOption={(props, option) => (
                <AutocompleteOption {...props}>
                    {/* This UI is neat but we need to replicate it on SearchSelect if we implement */}
                    {/*
                    {option?.title?.startsWith('Add "') && (
                        <ListItemDecorator>
                            <Add />
                        </ListItemDecorator>
                    )}
                    */}
                    {option?.title ?? option}
                </AutocompleteOption>
            )}
            filterOptions={(options, params) => {
                const filtered = filter(options, params);

                const { inputValue } = params;
                // Suggest the creation of a new value
                const isExisting = options.some((option) => inputValue === option.title);
                if (inputValue !== '' && !isExisting) {
                    filtered.push({
                        inputValue,
                        title: `Add "${inputValue}"`,
                    });
                }

                return filtered;
            }}

            {...restProps}
        />
    </>);

}
